import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {
  containerStyles, moduleSpacingStyles,
  normalizeStyles,
  typographyStyles,
} from '@webs/components-library/theming';

@customElement('webs-header-card')
export class HeaderCard extends LitElement {

  static styles = [
    normalizeStyles,
    moduleSpacingStyles,
    containerStyles,
    typographyStyles,
    css`
    .m-header-card {
      background-color: var(--color-white);
      box-shadow: 8px 0px 50px rgba(24, 26, 35, 0.08);
      border-radius: 8px;
      max-width: 287px;
      width: 100%;
    }

    .m-header-card__logo {
      padding:1.5rem;
    }

    .m-header-card__content {
      border-top: 1px solid #A8A39F;
      padding: 1.5rem;
    }

    .m-header-card__title {
      font-family: var(--font-family-alternative);
      font-weight: var(--font-weight-strong);
      font-size: .7rem;
      line-height: 1.3;
      text-transform: uppercase;
      color: var(--color-dark-grey);
    }
    `
  ]

  @property()
  title: string;

  @property({attribute: 'src'})
  imgSrc: string;

  @property({attribute: 'alt'})
  imgAlt = "logo";

  protected render(): unknown {
    return html`
      <div class="m-header-card">
      ${this.imgSrc? html`
        <div class="m-header-card__logo">
          <picture><img src="${this.imgSrc}" alt="${this.imgAlt}" loading="lazy" width="95"></picture>
        </div>
      `:""}
        <div class="m-header-card__content">
        ${this.title? html`
          <h5 class="m-header-card__title">${this.title}</h5>
        `:''}
          <slot></slot>
        </div>
      </div>
    `
  }
}
